import React from 'react';
import { Box, HStack, Text } from '@gluestack-ui/themed';
import { useTranslation } from 'react-i18next';

import { useChartTheme } from './useChartTheme';

/**
 * One release key beside the Tutor health heading.
 */
export function TutorHealthLegend() {
  const { t } = useTranslation();
  const theme = useChartTheme();

  return (
    <HStack space="md" alignItems="center" testID="tutor-health-legend">
      <HStack space="xs" alignItems="center">
        <Box
          width={20}
          height={0}
          borderTopWidth={2}
          borderStyle="dashed"
          sx={{ _web: { borderTopColor: theme.release } }}
          borderTopColor={theme.release}
          testID="tutor-health-legend-release-swatch"
        />
        <Text size="xs" color="$textSubtle">
          {t('admin.analytics.releaseLegend.release')}
        </Text>
      </HStack>
    </HStack>
  );
}
